import {format} from 'date-fns'
import {_} from 'i18n'
import React from 'react'
import {DollarSign} from 'react-feather'

import {BottomIcons, IConContainer, IconDetail} from '../styles'

const DEFAULT_STYLE = {
  color: '#383838',
}

const formatCurrency = (amount) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(amount)

const humanizeDate = (date) => {
  const months = {
    1: _`Janeiro`,
    2: _`Fevereiro`,
    3: _`Março`,
    4: _`Abril`,
    5: _`Maio`,
    6: _`Junho`,
    7: _`Julho`,
    8: _`Agosto`,
    9: _`Setembro`,
    10: _`Outubro`,
    11: _`Novembro`,
    12: _`Dezembro`,
  }

  var dateObj = new Date(date)
  var month = dateObj.getUTCMonth() + 1 //months from 1-12
  var day = dateObj.getUTCDate()
  var year = dateObj.getUTCFullYear()

  return `${day} de ${months[month]} de ${year}`
}

const BottomDetailIcons = ({created_at, city, project, benefits}) => {
  return (
    <BottomIcons>
      <IConContainer>
        <IconDetail className="fa fa-calendar fa-2x" aria-hidden="true" />
        <div>
          <span className="secundary-title">{_`Data de criação`}</span>
          <br />
          <span className="text-description-footer-1">{humanizeDate(created_at)}</span>
        </div>
      </IConContainer>
      {city ? (
        <IConContainer>
          <IconDetail className="fa fa-map-marker fa-2x" aria-hidden="true" />
          <div>
            <span className="secundary-title">{_`Localização`}</span>
            <br />
            <span className="text-description-footer-1">
              {city.name} - {city.state.uf}
            </span>
          </div>
        </IConContainer>
      ) : null}
      {project ? (
        <IConContainer>
          <IconDetail className="fa fa-file-text fa-2x" aria-hidden="true" />
          <div>
            <span className="secundary-title">{_`Categoria`}</span>
            <br />
            <span className="text-description-footer-1">{project.category_description}</span>
          </div>
        </IConContainer>
      ) : null}
      {project ? (
        <IConContainer>
          <IconDetail className="fa fa-database fa-2x" aria-hidden="true" />
          <div>
            <span className="secundary-title">{_`Investimento necessário`}</span>
            <br />
            <span className="text-description-footer-1">{formatCurrency(project.required_investment)}</span>
          </div>
        </IConContainer>
      ) : null}
      {project ? (
        <IConContainer>
          <IconDetail className="fa fa-money fa-2x" aria-hidden="true" />
          <div>
            <span className="secundary-title">{_`Investimento total`}</span>
            <br />
            <span className="text-description-footer-1">{formatCurrency(project.total)}</span>
          </div>
        </IConContainer>
      ) : null}
      {benefits.length ? (
        <IConContainer>
          <IconDetail className="fa fa-money fa-2x" aria-hidden="true" />
          <div>
            <span className="secundary-title">{_`Incentivos disponíveis ao investidor`}</span>
            <br />
            <span className="text-description-footer-1">{benefits.map((bn) => bn.type_description).join(' · ')}</span>
          </div>
        </IConContainer>
      ) : null}
    </BottomIcons>
  )
}

export default BottomDetailIcons
